// extracted by mini-css-extract-plugin
export default {"container":"Map_container__jAf6F","halfScreenContainer":"Map_halfScreenContainer__hS5ej"};